export const DESTINATION_FACETS = {
  koppen: "koppen_main_class",
  languages: "languages_iso",
  tempBand: (month: number) => `temp_band_${month}`,
  utcOffset: "utc_offset_hours",
} as const;
